import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './trending.css';

export default function Trending() {
  const [trendingPosts, setTrendingPosts] = useState([]);


  const main = {
    entertainments: 'Entertainment',
    movies: 'Movies',
    sports: 'Sports',
    indianhistory:'Indian History',
    untoldhistory:'Untold History',
    mysteries:'Mysteries',
    india:'India',
    world:'World',
    tech:'Tech',
    lifestyle:'Life Style',
    health:'Health & Wealth'
  };

  useEffect(() => {
    const collections = [
      'entertainments',
      'movies',
      'sports',
      'indianhistory',
      'untoldhistory',
      'mysteries',
      'india',
      'world',
      'tech',
      'lifestyle',
      'health',
    ];
  
    const fetchTrendingPosts = async () => {
      try {
        const allTrendingPosts = await Promise.all(
          collections.map(async (collection) => {
            const response = await fetch(
              `${process.env.REACT_APP_API_BASE_URL}/api/${collection}`
            );
            const data = await response.json();
  
            const mostViewedPost = data
              .filter((post) => post.views)
              .sort((a, b) => b.views - a.views)[0];
  
            if (mostViewedPost) {
              return { ...mostViewedPost, collection };
            }
            return null;
          })
        );
  
        setTrendingPosts(allTrendingPosts.filter((post) => post !== null));
      } catch (error) {
        console.error('Error fetching trending posts:', error);
      }
    };
  
    fetchTrendingPosts();
  }, []);  // No need to include collections as it's inside useEffect
  
  const navigate = useNavigate();

  const handlePostsClick = (id, collection) => {
    navigate(`/news/${id}/${collection}`);
  };

  return (
    <section id="trending-section">
      <div id="trending-cont">
        <h1>Trending Articles</h1>
        <div id="trendingarticle">
          {trendingPosts.length > 0 ? (
            trendingPosts.map((post, index) => (
              <div
                key={index}
                className="trending-post"
                onClick={() => handlePostsClick(post._id, post.collection)}
              >
                {post.thumbnail ? (
                  <img
                    src={`data:image/jpeg;base64,${post.thumbnail}`}
                    alt={post.title}
                  />
                ) : (
                  <p>No Thumbnail Available</p>
                )}
                <h2>{post.title}</h2>
                <p>
                  {main[post.collection]} -{' '}
                  {new Date(post.createdAt).toLocaleDateString()}
                </p>
              </div>
            ))
          ) : (
            <p>Loading trending posts...</p>
          )}
        </div>
      </div>
    </section>
  );
}
